var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputCopyActionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1752_53946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.744629 2.73541V1.44922C0.744629 1.03501 1.08041 0.699219 1.49463 0.699219H2.78081M0.744629 6.16139V8.66609M6.20681 0.699219H8.71148M12.0975 0.699219H13.2948C13.709 0.699219 14.0448 1.03501 14.0448 1.44922V2.73541M0.744629 12.0521V13.2493C0.744629 13.6636 1.08041 13.9993 1.49463 13.9993H2.78081",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2559 16.5518C17.2559 16.9659 16.9201 17.3018 16.5059 17.3018H5.45801C5.0438 17.3018 4.70801 16.9659 4.70801 16.5518V5.50391C4.70801 5.0897 5.0438 4.75391 5.45801 4.75391H16.5059C16.9201 4.75391 17.2559 5.0897 17.2559 5.50391V16.5518Z",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1752_53946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputCopyActionIcon);
export default __webpack_public_path__ + "static/media/InputCopyActionIcon.d0418616eeacbe7dc2f0d47458ab3708.svg";
export { ForwardRef as ReactComponent };